import React from 'react'
import ButtonAction, { ButtonActionProps } from 'components/shared/ButtonAction'

const AddSubAccountButton: React.FC<Omit<ButtonActionProps, 'text'>> = ({ ...props }) => {
  return <ButtonAction text='Add Sub-account' size='large' bold {...props} />
}

export default AddSubAccountButton
